import { useTranslation } from "react-i18next";
import { TProjectOverview } from "@/zapi-frontend/stores/project";
import { refsAt } from "@/zapi-frontend/shared/lib/figureRefs";
import { FigureText } from "../../../MemoIsland/FigureRefs/FigureTrigger";
import { HomeWidget } from "./HomeWidget";

export function KeyInsightsBlock({ overview }: { overview: TProjectOverview }) {
  const { t } = useTranslation("projectHome");
  if (!overview.keyInsights.length) return null;
  return (
    <HomeWidget title={t("overview.keyInsights")}>
      <div className="grid gap-3 @xl/widget:grid-cols-2 @3xl/widget:grid-cols-3">
        {overview.keyInsights.map((insight, i) => (
          <article key={i} className="flex flex-col gap-1.5 rounded-xl bg-muted/50 p-4">
            <h4 className="typo-label-md text-foreground">
              <FigureText text={insight.title} refs={refsAt(overview, `keyInsights[${i}].title`)} />
            </h4>
            <p className="typo-body-sm text-muted-foreground">
              <FigureText text={insight.body} refs={refsAt(overview, `keyInsights[${i}].body`)} />
            </p>
          </article>
        ))}
      </div>
    </HomeWidget>
  );
}
